const IMAGES = [
  {
    src: "/images/store/triple-j-bali-canggu-store-interior-01.webp",
    alt: "Triple J Bali Canggu store interior",
    label: "Canggu — Interior",
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    src: "/images/store/triple-j-bali-ubud-store-detail-01.webp",
    alt: "Triple J Bali Ubud store detail",
    label: "Ubud — Detail",
    span: "lg:col-span-5",
  },
  {
    src: "/images/lifestyle/triple-j-bali-lifestyle-shopping-01.webp",
    alt: "Triple J Bali shopping moment",
    label: "Bali Boutique Service",
    span: "lg:col-span-5",
  },
];

const BoutiqueExperience = () => (
  <section
    id="boutique"
    data-testid="boutique-experience"
    className="py-20 md:py-28 bg-[hsl(var(--background))]"
  >
    <div className="container-tjb">
      <div className="max-w-2xl">
        <p className="eyebrow">Boutique Experience</p>
        <h2 className="h-section mt-3">A Bali Boutique for Easy Styling</h2>
        <p className="mt-5 text-base md:text-lg text-[hsl(var(--ink))]/80 leading-relaxed">
          Find outfits that feel light, breathable, and easy to wear in Bali’s
          tropical weather. Our team can help you choose pieces for your day
          plans, from beach walks to dinner looks.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 lg:grid-rows-2 gap-4 md:gap-5 lg:h-[640px]">
        {IMAGES.map((it) => (
          <figure
            key={it.src}
            className={`relative overflow-hidden bg-[hsl(var(--sand))] ${it.span}`}
          >
            <img
              src={it.src}
              alt={it.alt}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[1400ms] hover:scale-105"
              style={{ minHeight: "260px" }}
            />
            <figcaption className="absolute bottom-3 left-3 badge-soft">
              {it.label}
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default BoutiqueExperience;
